var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1742.736,
    height: 177.776,
    viewBox: "0 0 1742.736 177.776",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M1350.311,763.861c-79.915-29.389-310.82-15.679-259.283-42.21,82.474-42.456-22.151-73.346-45.163-79.315-114.282-29.646-335.738-49.93-532.526-46.325q-15.182.277-30.123.749c-22.843.714-45.244,1.774-67,3.2q-23.019,1.5-44.919,3.565h-.011q-13.8,1.3-27.1,2.828-19.838,2.277-38.383,5.077-4.839.734-9.592,1.506c-20.639,3.341-39.926,7.214-57.516,11.641a655.693,655.693,0,0,1-93.6,16.189c-176.114,18.055-348.957-25.992-507.34,13.826a273.684,273.684,0,0,0-30.18,9.148v89.632a20,20,0,0,0,20,20H1333.306A19.964,19.964,0,0,0,1350.311,763.861Z",
    transform: "translate(392.425 -595.596)",
    fill: "#e1eff9",
    opacity: 0.502
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenWave);
export default __webpack_public_path__ + "static/media/greenWave.c7b00a52aa8be04018c06ca4f88d34af.svg";
export { ForwardRef as ReactComponent };